import { ReportsServiceAPI } from '@API/data-services/reports-service'
import { WeeklyReport } from '../weekly-report'

export const SearchAnalytics = () => {
  return (
    <WeeklyReport
      title="Search Analytics"
      fetchReportUrl={ReportsServiceAPI.getSearchAnalyticsReportUrl}
    />
  )
}
